import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    backgroundColor: 'common.white',
    padding: {
      xs: '16px 20px',
      md: '24px',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    borderRadius: '16px',
    maxWidth: {
      md: '294px',
    },
    textDecoration: 'none',
  },
  image: {
    height: '246px',
    width: '100%',
    borderRadius: '16px',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
